import React from "react";
import ProjectCard from "../ProjectCard";
import { sky, cddri } from "../../assets/index";

const ProfessionalProjects = () => {
  const projectList = [
    {
      header: "SKY TV Newzealand",
      duration: "July 2021 - June 2023",
      src: sky,
      description:
        "Contributed to backend modernization and integrations for a TV streaming platform, improving performance, reliability, and billing integrations.",
      visitLink: "https://www.sky.co.nz/",
      codeLink: "https://github.com/anshuman0799",
    },
    {
      header: "Voltage DSP",
      duration: "Oct 2025 - Present",
      src: cddri,
      description:
        "Worked on an enterprise content discovery application, improving indexing, search performance, and background processing for large-scale repositories; integrated AI-based classification and false-positive detection to improve scan accuracy.",
      visitLink:
        "https://www.opentext.com/ca/products/core-data-discovery-risk-insights",
      codeLink: "https://github.com/anshuman0799",
    },
  ];

  return (
    <section
      id="professional-projects"
      className="w-full h-full py-10 flex flex-col border-b-[1px] border-b-black font-titleFont pb-20"
    >
      <div className="max-w-full lg:max-w-[1280px] w-full h-full m-auto px-4 xl:px-8">
        <div className="h-full md:w-[85%] mx-auto items-center gap-4">
          <h2 className="text-3xl lg:text-4xl w-full flex justify-center text-black xl:pt-4">
            Professional Projects
          </h2>
          <div className="mt-12 h-full">
            {projectList.map((item, i) => {
              return (
                <ProjectCard
                  key={i}
                  header={item.header}
                  duration={item.duration}
                  srcImage={item.src}
                  orderFirst={i % 2 === 0}
                  description={item.description}
                  visitLink={item.visitLink}
                  codeLink={item.codeLink}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfessionalProjects;
